import { useCreateFieldGetter } from '@/common/customisation/composables';
import { PUI } from '@pleased-npm/fe-customisation';

/**
 * Composable for CSAT rating options heading customisation
 * Returns heading text and styling
 */
export const useCsatRatingOptionsHeadingCustomisation = () => {
  const { getField, isVisible } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.CSAT,
    sectionKey: PUI.CSAT_SECTION_KEYS.RATING_OPTIONS_HEADING,
    blockKey: PUI.CSAT_BLOCK_KEYS.RATING_OPTIONS,
  });

  const textContent = getField(PUI.COMMON_FIELD_KEYS.TEXT_CONTENT);
  const textColor = getField(PUI.COMMON_FIELD_KEYS.TEXT_COLOR);

  return {
    isVisible,
    textContent,
    textColor,
  };
};

/**
 * Composable for CSAT rating options styles customisation
 * Returns styles for rating options
 */
export const useCsatRatingOptionsStylesCustomisation = () => {
  const { getField } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.CSAT,
    sectionKey: PUI.CSAT_SECTION_KEYS.OPTION_STYLES,
    blockKey: PUI.CSAT_BLOCK_KEYS.RATING_OPTIONS,
  });

  const labelColor = getField(PUI.COMMON_FIELD_KEYS.TEXT_COLOR);
  const selectedLabelColor = getField(PUI.COMMON_FIELD_KEYS.SELECTED_TEXT_COLOR);

  return {
    labelColor,
    selectedLabelColor,
  };
};

/**
 * Composable for individual CSAT rating option customisation
 * @param optionNumber - The rating option number (1-5)
 */
export const useCsatRatingOptionCustomisation = (optionNumber: 1 | 2 | 3 | 4 | 5) => {
  const sectionKeyMap = {
    1: PUI.CSAT_SECTION_KEYS.OPTION_1,
    2: PUI.CSAT_SECTION_KEYS.OPTION_2,
    3: PUI.CSAT_SECTION_KEYS.OPTION_3,
    4: PUI.CSAT_SECTION_KEYS.OPTION_4,
    5: PUI.CSAT_SECTION_KEYS.OPTION_5,
  };

  const { getField, isVisible } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.CSAT,
    sectionKey: sectionKeyMap[optionNumber],
    blockKey: PUI.CSAT_BLOCK_KEYS.RATING_OPTIONS,
  });

  const labelText = getField(PUI.COMMON_FIELD_KEYS.LABEL_TEXT);

  return {
    isVisible,
    labelText,
  };
};
